import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Loader } from "@/components/site/Loader";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";
import Home from "@/pages/Home";
import MenuPage from "@/pages/Menu";
import Contatti from "@/pages/Contatti";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const INTRO_MS = 1900;

const PublicLayout = () => (
  <>
    <Navbar />
    <main>
      <Outlet />
    </main>
    <Footer />
    <WhatsAppFloat />
  </>
);

function App() {
  const [intro, setIntro] = useState(() => {
    window.__mpIntroEnd = Date.now() + INTRO_MS;
    return true;
  });

  useEffect(() => {
    const t = setTimeout(() => setIntro(false), INTRO_MS);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <SmoothScroll />
        <AnimatePresence>{intro && <Loader key="loader" />}</AnimatePresence>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/contatti" element={<Contatti />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
